import { render } from "./TicketDetails.vue?vue&type=template&id=3e41b04a"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_d537e74c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__